<script setup lang="ts">
import { ref, watch, nextTick } from 'vue'
import { useChatStore } from '@/stores/chat'
import BotMessage from './BotMessage.vue'
import UserMessage from './UserMessage.vue'
import TypingIndicator from './TypingIndicator.vue'

const chatStore = useChatStore()
const messagesContainer = ref<HTMLElement | null>(null)

// Auto-scroll to bottom when messages change
watch(
  () => chatStore.messages.length,
  async () => {
    await nextTick()
    scrollToBottom()
  }
)

watch(
  () => chatStore.isTyping,
  async () => {
    await nextTick()
    scrollToBottom()
  }
)

function scrollToBottom() {
  if (messagesContainer.value) {
    messagesContainer.value.scrollTo({
      top: messagesContainer.value.scrollHeight,
      behavior: 'smooth'
    })
  }
}
</script>

<template>
  <div
    ref="messagesContainer"
    class="h-full overflow-y-auto px-4 py-4 space-y-3 scrollbar-hide"
  >
    <!-- Messages -->
    <template v-for="message in chatStore.messages" :key="message.id">
      <BotMessage
        v-if="message.type === 'bot'"
        :content="message.content"
      />
      <UserMessage
        v-else-if="message.type === 'user'"
        :content="message.content"
      />
    </template>

    <!-- Typing indicator -->
    <TypingIndicator v-if="chatStore.isTyping" />

    <!-- Current input slot -->
    <slot />
  </div>
</template>
